import { render } from "./NotificationDropdown.vue?vue&type=template&id=6134f3a2"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script